module.exports = __webpack_public_path__ + "img/PT23.3d3ea62d.png";